import React, { useContext } from 'react';
import styled from 'styled-components';
import { Tooltip } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { ReactComponent as BaseClientBlockedIcon } from '@ubeya/shared-web/assets/blocked.svg';

const ClientBlockedIcon = styled(BaseClientBlockedIcon)`
  margin-bottom: 3px;
  margin-right: 1px;
  cursor: pointer;

  width: 16px;
  height: 16px;

  :hover {
    transform: scale(1.2);
  }
`;

const BlockedEmployeeButton = ({ onChange }) => {
  const { t } = useContext(ConfigContext);

  return (
    <Tooltip body={t('clientBlockedTooltip')}>
      <ClientBlockedIcon onClick={onChange} />
    </Tooltip>
  );
};

export default BlockedEmployeeButton;
